import errors, { errorString } from "../Constants/errors";
import { AxiosError } from "axios";
import { UpdatePasswordError } from "../Queries";

export type GenericError = { [key: string]: unknown; errors?: { code: errorString }[] } & {
  error?: errorString;
};

export function getErrorCode(error: AxiosError<GenericError>) {
  const message: errorString | undefined =
    error?.response?.data?.errors?.[0]?.code || error?.response?.data?.error;
  return message ? errors[message] : undefined;
}

export function getPasswordError(error: AxiosError<UpdatePasswordError>) {
  const message: errorString | undefined =
    error?.response?.data?.error_description?.previous_password?.[0] ||
    error?.response?.data?.error_description?.new_password?.[0];
  return message ? errors[message] : undefined;
}
